import React, { useEffect, useState } from 'react';
import FormSelect from '../../commons/FormSelect';
import { SingleCombo } from './styles';
import { getDevice } from '@panel/commons/helpers';

export const ComboLocation = ({
  title,
  value,
  disabled,
  placeholder,
  filterPlaceholder,
  locationData,
  errors,
  onChange,
  isMobile = false,
  noOptionToClean = false
}) => {
  const [dataToSelectOptions, setDataToSelectOptions] = useState([]);

  useEffect(() => {
    const formattedOptions =
      locationData?.map(location => ({ value: location.location_id, description: location.name })) || [];
    setDataToSelectOptions(formattedOptions);
  }, [locationData]);

  return (
    <SingleCombo isMobile={isMobile}>
      <FormSelect
        hasError={errors}
        isDisabled={disabled}
        label={title}
        options={dataToSelectOptions || []}
        value={value || ''}
        onChange={onChange}
        placeholder={value ? value : placeholder}
        filterPlaceholder={filterPlaceholder}
        device={getDevice()}
        noOptionToClean={noOptionToClean}
        filterable
      />
    </SingleCombo>
  );
};
